import { render, staticRenderFns } from "./AbsencesAll.vue?vue&type=template&id=28958ccd"
import script from "./AbsencesAll.vue?vue&type=script&lang=js"
export * from "./AbsencesAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports